// extracted by mini-css-extract-plugin
export var button = "_t-0";
export var buttonContent = "_t-e";
export var buttonGroup = "_t-c";
export var dontRestrainIconWidth = "_t-a";
export var dropdownButton = "_t-b";
export var iconContainer = "_t-9";
export var lg = "_t-4";
export var md = "_t-3";
export var pending = "_t-f";
export var sm = "_t-2";
export var spinner = "_t-d";
export var squared = "_t-8";
export var wrapText = "_t-g";
export var xl = "_t-5";
export var xs = "_t-1";
export var xxl = "_t-6";
export var xxxl = "_t-7";